import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    infinite: {
      margin: [Spacings.s56, Spacings.s0],
      paddingBottom: Spacings.s0,
    },
    infiniteItem: {
      aspectRatio: 1.04,
      '& > img': {
        padding: [Spacings.s0, Spacings.s4],
        display: 'block',
      },
    },
    skeleton: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2,
      padding: 0,
    },
    skeletonItem: {
      aspectRatio: 1.5,
      padding: [0, 4],
    },
  }),
  { name: 'brands-remixing' },
);

export default useStyles;
